<div class="blade-wrapper">
    <div class="blade-header" *ngIf="!showInDialog || (showInDialog && hasToolbar)">
      <div           class="blade-tools">
          <app-toolbar [toolbar]="toolbar">
              <ng-template 
                toolbarToolDef="create_transfer" let-tool>
                <ng-container  *ngIf="tool.hasButtonsToShow">
                <button mat-button
                        data-cy="button"
                        class="datex-button"
                        [disabled]="tool.control.readOnly || tool.control.disabled"
                        [ngStyle]="tool.control.styles.style"
                        [ngClass]="tool.control.styles.classes"
                        [matTooltip]="tool.control.tooltip"
                        matTooltipClass="datex-control-tooltip"
                        (click)="on_create_transfer_clicked($event)"
                        >
                  <div class="button-label">
                    <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                      <div class="button-icon">
                        <i data-cy="button-icon" class="datex-default-spinner"></i>
                      </div>
                    </ng-container>
                    <ng-template #showIcon>
                      <div class="button-icon">
                        <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                      </div>
                    </ng-template>
                    <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                  </div>
                
                </button>
                </ng-container>
              </ng-template>
          </app-toolbar>
      </div>
      <ng-content></ng-content>
    </div>

  <div class="blade-content">
    <div class="datex-hub">
      <ng-container
                    *ngIf="initialized ">
        <div class="hubdata">
          <h1 class="hubname" *ngIf="!showInDialog">{{hubTitle}}</h1>
          <h6 class="hubdesc">{{hubDescription}}</h6>
          <div class="hub-filters">
            <div class="fieldsetsGroup">
              <div [formGroup]="formGroup"
                   class="formdata">
                <div data-cy="fieldset-id-filters"
                     *ngIf="!filtersets.filters.hidden && !filtersets.filters.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': filtersets.filters.collapsible }">
                    <div *ngIf="!filtersets.filters.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="filtersets.filters.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{filtersets.filters.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="filtersets.filters.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !filtersets.filters.expanded, 'icon-ic_fluent_chevron_up_20_filled': filtersets.filters.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="filtersets.filters.expanded"
                         class="fieldsetsGroup">
                            <div data-cy="field-id-warehouses" *ngIf="!filters.warehouses.hidden && !filters.warehouses.removed" 
                                  class="field-container standard {{filters.warehouses.invalid ? 'invalid' : ''}} {{filters.warehouses.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.warehouses.styles.style"
                                  [ngClass]="filters.warehouses.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.warehouses.label + (filters.warehouses.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.warehouses.label}}<span *ngIf="filters.warehouses.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Locations-warehouses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.warehouses.control.type"
                                  formControlName="warehouses"
                                  (displayTextChange)="filters.warehouses.control.displayText=$event"
                                  [placeholder]="filters.warehouses.control.placeholder"
                                  [styles]="filters.warehouses.control.styles"
                                  [tooltip]="filters.warehouses.control.tooltip"
                              >
                              </Locations-warehouses_dd_multi>
                              <ng-container *ngIf="filters.warehouses.invalid">
                                <ng-container *ngFor="let error of filters.warehouses.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-source_project" *ngIf="!filters.source_project.hidden && !filters.source_project.removed" 
                                  class="field-container standard {{filters.source_project.invalid ? 'invalid' : ''}} {{filters.source_project.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.source_project.styles.style"
                                  [ngClass]="filters.source_project.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.source_project.label + (filters.source_project.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.source_project.label}}<span *ngIf="filters.source_project.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-projects_dd_single 
                                  data-cy="selector"
                                  [type]="filters.source_project.control.type"
                                  formControlName="source_project"
                                  (displayTextChange)="filters.source_project.control.displayText=$event"
                                  [placeholder]="filters.source_project.control.placeholder"
                                  [styles]="filters.source_project.control.styles"
                                  [tooltip]="filters.source_project.control.tooltip"
                                [statusId]="$fields_source_project_selector_inParams_statusId"
                              >
                              </Owners-projects_dd_single>
                              <ng-container *ngIf="filters.source_project.invalid">
                                <ng-container *ngFor="let error of filters.source_project.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-target_project" *ngIf="!filters.target_project.hidden && !filters.target_project.removed" 
                                  class="field-container standard {{filters.target_project.invalid ? 'invalid' : ''}} {{filters.target_project.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.target_project.styles.style"
                                  [ngClass]="filters.target_project.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.target_project.label + (filters.target_project.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.target_project.label}}<span *ngIf="filters.target_project.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <Owners-projects_dd_single 
                                  data-cy="selector"
                                  [type]="filters.target_project.control.type"
                                  formControlName="target_project"
                                  (displayTextChange)="filters.target_project.control.displayText=$event"
                                  [placeholder]="filters.target_project.control.placeholder"
                                  [styles]="filters.target_project.control.styles"
                                  [tooltip]="filters.target_project.control.tooltip"
                                [statusId]="$fields_target_project_selector_inParams_statusId"
                              >
                              </Owners-projects_dd_single>
                              <ng-container *ngIf="filters.target_project.invalid">
                                <ng-container *ngFor="let error of filters.target_project.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>              <div data-cy="field-id-statuses" *ngIf="!filters.statuses.hidden && !filters.statuses.removed" 
                                  class="field-container standard {{filters.statuses.invalid ? 'invalid' : ''}} {{filters.statuses.control.disabled ? 'field-container-disabled' : ''}}"
                                  [ngStyle]="filters.statuses.styles.style"
                                  [ngClass]="filters.statuses.styles.classes">
                              <div class="label-container"
                                   [matTooltip]="filters.statuses.label + (filters.statuses.required ? ' (required)' : '')"
                                   matTooltipClass="datex-control-tooltip">
                                <label data-cy="field-label" class="datex-label">{{filters.statuses.label}}<span *ngIf="filters.statuses.required" class="required-asterisk">*</span>
                                </label>
                              </div>
                              <InventoryTransfers-inventory_transfer_statuses_dd_multi 
                                  data-cy="selector-multi"
                                  [type]="filters.statuses.control.type"
                                  formControlName="statuses"
                                  (displayTextChange)="filters.statuses.control.displayText=$event"
                                  [placeholder]="filters.statuses.control.placeholder"
                                  [styles]="filters.statuses.control.styles"
                                  [tooltip]="filters.statuses.control.tooltip"
                              >
                              </InventoryTransfers-inventory_transfer_statuses_dd_multi>
                              <ng-container *ngIf="filters.statuses.invalid">
                                <ng-container *ngFor="let error of filters.statuses.errors">
                                  <span class="invalid-message">
                                    {{error}}
                                  </span>
                                </ng-container>
                              </ng-container>
                            </div>            </div>
              
                          <div class="fieldset-details" *ngIf="!filtersets.filters.expanded">
              
              
                          </div>
                        </div>
                      </div>
                    </div>
            </div>
          </div>
        </div>


        <div class="datex-tabcontrol" *ngIf="!this.rootTabGroup.allTabsHidden">
          <div class="tab-container">
            <div *ngIf="tabs.inventory_transfers.hasTabToShow" class="tab" data-cy="tab-inventory_transfers">
              <h2 [className]="tabs.inventory_transfers.active? 'active': ''" (click)="tabs.inventory_transfers.activate()">{{tabs.inventory_transfers.title}}</h2>
            </div>
          </div>
        
              <FootprintManager-inventory_transfers_grid *ngIf="tabs.inventory_transfers.active"
              #$tabs_inventory_transfers
              [warehouses]="$tabs_inventory_transfers_inventory_transfers_grid_inParams_warehouses"
              [sourceProjectId]="$tabs_inventory_transfers_inventory_transfers_grid_inParams_sourceProjectId"
              [targetProjectId]="$tabs_inventory_transfers_inventory_transfers_grid_inParams_targetProjectId"
              [statusIds]="$tabs_inventory_transfers_inventory_transfers_grid_inParams_statusIds"
              ($refreshEvent)="refresh(false, false, '$tabs_inventory_transfers')">
              </FootprintManager-inventory_transfers_grid>
        </div>

      </ng-container>
    </div>
  </div>
</div>